/**
 * `name` if nothing is called that yet, else the first of `stem_2.ext`, `stem_3.ext`… that is free.
 * Uploads to My Files overwrite without asking, so a save must pick an unused name itself.
 */
export function freeFileName(name: string, isTaken: (candidate: string) => boolean): string {
  if (!isTaken(name)) {
    return name
  }

  // A leading dot is part of the stem: `.env` has no extension.
  const dot = name.lastIndexOf('.')
  const [stem, ext] = dot > 0 ? [name.slice(0, dot), name.slice(dot)] : [name, '']

  for (let n = 2; ; n++) {
    const candidate = `${stem}_${n}${ext}`
    if (!isTaken(candidate)) {
      return candidate
    }
  }
}
